export function compareSemVer(version: string, compareToVersion: string): -1 | 0 | 1 {
  const pa = version.split('.');
  const pb = compareToVersion.split('.');

  for (let i = 0; i < 3; i++) {
    const na = Number(pa[i]);
    const nb = Number(pb[i]);

    if (na > nb) {
      return 1;
    }

    if (nb > na) {
      return -1;
    }

    if (!isNaN(na) && isNaN(nb)) {
      return 1;
    }

    if (isNaN(na) && !isNaN(nb)) {
      return -1;
    }
  }
  return 0;
}
